import "./careers";
import "./savings";
import "./pricing";
import "./scripts";

import Vue from 'vue';
import PasswordInput from "./login/PasswordInput";
import PasswordInputWithToggle from "./login/PasswordInputWithToggle";
import MfaModal from "./login/MfaModal";
import LibFaq from "./faq/LibFaq";
// import {VueTelInput} from "@gadzoom/ui-library/dist/scripts/vue/vue-tel-input";
import {VueTelInput} from "./registration/vue-tel-input";

window.Vue = Vue;
Vue.component("password-input", PasswordInput)
Vue.component("password-input-with-toggle", PasswordInputWithToggle)
Vue.component("lib-faq", LibFaq)
Vue.component("mfa-modal", MfaModal)
Vue.component("vue-tel-input", VueTelInput)